'use client'
import '@/styles/globals.css'
import { cn } from '@/utils/style'
import Providers from './Providers'
import { basePathify } from '@/utils/nextjs'
import Analytics from '@/services/analytics'
import { fontInterSans } from './fonts'
import { WindowLoadedLogger } from '@/services/logs'

interface RootLayoutProps {
  children: React.ReactNode
}

// export const metadata = {
//   title: {
//     default: siteConfig.name,
//     template: `%s | ${siteConfig.name}`,
//   },
//   description: siteConfig.description,
//   keywords: [
//     'Next.js',
//     'React',
//     'Tailwind CSS',
//     'Server Components',
//     'Radix UI',
//   ],
//   themeColor: [
//     { media: '(prefers-color-scheme: light)', color: 'white' },
//     { media: '(prefers-color-scheme: dark)', color: 'black' },
//   ],
//   openGraph: {
//     type: 'website',
//     locale: 'en_US',
//     url: siteConfig.url,
//     title: siteConfig.name,
//     description: siteConfig.description,
//     siteName: siteConfig.name,
//     // images: [
//     //   {
//     //     url: (`${configs.FRONT_URL}/og.jpg`),
//     //     width: 1200,
//     //     height: 630,
//     //     alt: siteConfig.name,
//     //   },
//     // ],
//   },
//   twitter: {
//     card: 'summary_large_image',
//     title: siteConfig.name,
//     description: siteConfig.description,
//     // images: [`${siteConfig.url}/og.jpg`],
//     creator: '@shadcn',
//   },
//   icons: {
//     icon: '/favicon.ico',
//     shortcut: '/favicon-16x16.png',
//     apple: '/apple-touch-icon.png',
//   },
//   // manifest: `${siteConfig.url}/site.webmanifest`,
// }

// const extensionClass = "extension-ledger-activated"

export default function RootLayout({ children }: RootLayoutProps) {
  const classNames =
    typeof document !== 'undefined' ? document.body.className : ''

  // useEffect(() => {

  // }, [])

  return (
    <html
      lang="en"
      className={cn(
        'bg-white font-inter-sans text-slate-900 antialiased',
        fontInterSans.variable,
      )}
    >
      <head>
        <link rel="icon" href={basePathify('/favicon.svg')} sizes="any" />
      </head>
      <body className={cn('min-h-screen', classNames)}>
        <Providers>
          {children}
          <WindowLoadedLogger />
          <Analytics />
        </Providers>
        {/* <TailwindIndicator /> */}
        <div id="modal_root" />
      </body>
    </html>
  )
}
